export default "__VITE_ASSET__7b4bef0c__"